import { useEffect, useState } from "react";
import { getUserList } from "../api/user";
import useErrorHandler from "./useErrorHandler";

const userListCacheMap = new Map();

export default function useUserList(token) {
  const [userList, setUserList] = useState([]);
  const [error, setError] = useState(null);
  const errorHandler = useErrorHandler();

  useEffect(() => {
    if (userListCacheMap.has(token)) {
      setUserList(userListCacheMap.get(token));
    } else if (token) {
      getUserList(token)
        .then(({ data }) => {
          setUserList(data.data);
          userListCacheMap.set(token, data.data);
          setError(null);
        })
        .catch((error) => {
          errorHandler(error);
          setError(error);
        });
    }
  }, [token]);

  return { userList, error };
}
